import React from "react";
import './Button.scss';

const Button = (props) => {
    return (
        <button
            type={props.type !== undefined ? props.type : 'submit'}
            ref={props.inputRef}
            onClick={props.onclickCallback}
            className={`button-1 ${props.btnClassName}`}
            disabled={props.isLoading || props.disabled}
        >
            {
                props.isLoading && (<i className="fas fa-spinner fa-spin mr-5px" />)
            }
            {
                props.icon && !props.isLoading && (
                    <i className={`${props.icon} mr-5px`}></i>
                )
            }
            {props.btnText}
        </button>
    );
}
export default Button;